import Backend from "../../../backend";
import { useFetch } from "./../../Utility/hooks";

export function useBackgrounds(projectId) {
  const queryFunction = async () => {
    if (!projectId) {
      return [];
    }
    return Backend.__getBackgrounds(projectId);
  };
  return useFetch(queryFunction, []);
}
